import {
    Button, ButtonGroup, DialogBody, DialogContainer, DialogFooter, DialogHeader, Link
} from '@wg/wows-react-uikit';
import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import styles from './RulesDialog.scss';
import { closeRulesDialog } from '~/store/dialogs';
import { i18n_Props } from '~/i18n';
import { RootState } from '~/store';
import * as Api from '~/types';
import ClientApi from '~/clientApi';
import Text from '~/Components/Text/Text';

type OwnProps = i18n_Props;

interface DispatchProps {
    closeRulesDialog: () => void,
}

interface StateProps {
    completedActions?: Array<string> | null,
    rules: Array<Api.Rule>,
    isInGame: boolean,
    readMoreLink?: string,
}

export type Props = StateProps & OwnProps & DispatchProps;

class RulesDialog extends PureComponent<Props> {
    openExternalUrl = () => {
        if (!this.props.readMoreLink) {
            return;
        }

        ClientApi.openExternalUrl(this.props.readMoreLink as string);
    };

    render() {
        const { t, rules } = this.props;

        const readMoreText = t('Читать подробнее на портале игры');

        return (
            <DialogContainer>
                <DialogHeader>{t('Правила')}</DialogHeader>
                <DialogBody>
                    <div className={styles.wrapper}>
                        {rules.map((rule, index) => (
                            <div className={styles.paragraph} key={`rule_${index}`}>
                                <div className={styles.title}>{rule.title}</div>
                                <div className={styles.text}>
                                    {rule.rules?.map((ruleText, textIndex) => (
                                        <Text
                                            key={`rule_${index}-${textIndex}`}
                                            str={ruleText}
                                            clickableVehicles={true}
                                        />
                                    ))}
                                </div>
                            </div>
                        ))}

                        {this.props.readMoreLink && (
                            <div className={styles.portalLink}>
                                {this.props.isInGame ? (
                                    <Link
                                        arrow=""
                                        isActionLink={false}
                                        onClick={this.openExternalUrl}
                                    >
                                        {readMoreText}
                                    </Link>
                                ) : (
                                    <a href={this.props.readMoreLink}>{readMoreText}</a>
                                )}
                            </div>
                        )}
                    </div>
                </DialogBody>
                <DialogFooter>
                    <ButtonGroup>
                        <Button isFlat={true} onClick={this.props.closeRulesDialog}>
                            {t('Закрыть')}
                        </Button>
                    </ButtonGroup>
                </DialogFooter>
            </DialogContainer>
        );
    }
}

const mapStateToProps = (state: RootState): StateProps => ({
    completedActions: state.app.account.completedActionsIds,
    isInGame: state.app.isInGame,
    rules: state.app.rules,
    readMoreLink: state.app.readMoreLink,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, unknown, AnyAction>): DispatchProps => {
    return {
        closeRulesDialog: () => {
            dispatch(closeRulesDialog());
        },
    };
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(RulesDialog));
